import { Button } from "reactstrap";
import pluralize from "pluralize";

import ThumbnailWidget from "../../Widgets/ThumbnailWidget/ThumbnailWidget";
import SelectableInput from "../../SelectableInput/SelectableInput";
import SkeletonLoader from "../../../elements/SkeletonLoader";
import { GetRecordName } from "../../../utils/RecordUtils";
import { ImageFieldPresentation } from "../RecordNameCell";
import useAllTags from "../../../hooks/useAllTags";
import useModule from "../../../hooks/useModule";

interface ReferenceTooltipProps {
  record: Record<string, any>;
  onView?: () => void;
  imageField?: string;
  imageFieldPresentation?: ImageFieldPresentation;
  description?: string;
}

const ReferenceTooltip = ({
  record,
  onView,
  imageField,
  imageFieldPresentation,
  description,
}: ReferenceTooltipProps) => {
  const { module } = useModule(record?._ModuleAPIName);
  const {
    tags: allTags,
    getTags,
    tagsLoading,
  } = useAllTags(record?._ModuleAPIName);

  const tags = record?.Tags || [];

  const recordName = GetRecordName(module!, record);

  return (
    <div
      className="d-flex justify-content-between align-items-center bg-ultralight--hover cursor-pointer px-3 py-3"
      style={{ width: 350 }}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onView && onView();
      }}
    >
      <div>
        <div
          style={{ fontSize: 12 }}
          className="d-flex align-items-center text-muted font-weight-500 mb-1"
        >
          {module?.Name && pluralize.singular(module?.Name)}
          {!!record?._TenantUser && (
            <img
              className="ml-1"
              src="/img/GCLogo512x512.png"
              style={{
                height: 20,
                width: 20,
              }}
            />
          )}
          {!!record?._Synced && !record?._TenantUser && (
            <i
              className="mdi mdi-cloud-sync-outline pl-2 m-0 text-info"
              style={{ fontSize: 20 }}
            />
          )}
        </div>
        <div style={{ width: 285 }} className="tw:flex tw:items-center">
          {imageField && (
            <div style={{ position: "relative", top: description ? 1 : 0 }}>
              <ThumbnailWidget
                record={record}
                imageKey={imageField}
                mode={imageFieldPresentation}
                size="md"
              />
            </div>
          )}
          <div style={{ width: "calc(100% - 20px)" }}>
            <h3 className="mb-0 mt-0 text-truncate" style={{ lineHeight: 1.3 }}>
              {recordName ? recordName : "(No Name)"}
            </h3>
            {description && (
              <div
                style={{ lineHeight: 1.2 }}
                className="text-small text-truncate"
              >
                {description}
              </div>
            )}
          </div>
        </div>
        <div className="mt-1" style={{ width: 285, overflow: "hidden" }}>
          {tagsLoading ? (
            <SkeletonLoader />
          ) : tags?.length > 0 ? (
            // @ts-ignore
            <SelectableInput
              mode="r"
              options={allTags}
              value={getTags(tags)}
              multiselect={true}
              labelKey="Name"
              valueKey="id"
              colorKey="Color"
              inputDisplayMode="subtle"
              maxValuesDisplayed={2 as any}
              groupBy={["Scope", "Type"] as any}
              groupByLabels={
                {
                  Person: "Your Tags",
                  Cloud: "Cloud Tags",
                  Module: "Module Tags",
                  Workspace: "Workspace Tags",
                } as any
              }
            />
          ) : (
            <></>
          )}
        </div>
      </div>
      {onView && (
        <Button
          onClick={() => onView()}
          className="btn-icon-only ml-2"
          size="sm"
          outline
        >
          <i className="mdi mdi-chevron-right"></i>
        </Button>
      )}
    </div>
  );
};

export default ReferenceTooltip;
